module.exports = __webpack_public_path__ + "img/hr-learning-img.29097d21.png";